import React, {useEffect, useState, MouseEvent } from "react";
import { displayCountryDesc, convertStringToDate } from "../Services/services";
import { useFileUploadInfoData } from "../Contexts/fileUploadInfoProvider";
import ButtonNavigation from "../BottomNavigation/bottomNavigation";
import BOListTemplates from "../DocumentTemplates/bolisttemplates";
import DocuTemplates from "../DocumentTemplates/docutemplates";
import Input from "../Items/Input";
import Select from "../Items/Select";
import Datepicker from "../Items/datePicker";
import info_small from "../../images/info_small.gif";
import FileUploadTexts from "./fileUploadTexts";
import { allowedFileExtensions, getSecurityType } from "../Services/services";
import { UserLoginData } from "../../TypeScript/interfaces";
import "./tooltip.css";

interface Props {
  selectedPage: string;
  country: string;
  selectedOption: string;
  userLoginData: UserLoginData;
  warnings: string[];
  setSelectedPage: React.Dispatch<React.SetStateAction<string>>;
  setSelectedCountry: React.Dispatch<React.SetStateAction<string>>;
  setSelectedOption: React.Dispatch<React.SetStateAction<string>>;  
  setWarnings: React.Dispatch<React.SetStateAction<string[]>>; 
}

const FileUploadInformation: React.FC<Props> = (props) => {
  const {
    selectedPage,
    country,
    selectedOption,
    setSelectedPage,
    setSelectedCountry,
    setSelectedOption,
    setWarnings,
    userLoginData,
  } = props;

  const [errors, setErrors] = useState({
    salutationErr: false,
    salutationErrTxt: "",
    firstNameErr: false,
    firstNameErrTxt: "",
    lastNameErr: false,
    lastNameErrTxt:"",
    customerOrgErr: false,
    customerOrgErrTxt: "",
    phoneNbrErr: false,
    phoneNbrErrTxt: "",
    emailErr: false,
    emailErrTxt: "",
    ccFirstErr: false,
    ccFirstErrTxt: "",
    ccSecondErr: false,
    ccSecondErrTxt:"",
    acctNbrErr: false,
    acctNbrErrTxt: "",
    platformErr: false,
    securityCodeErr: false,
    isinErr: false,
    isinErrTxt: "",
    commonCodeErr: false,
    commonCodeErrTxt: "",
    securityNameErr: false,
    securityNameErrTxt: "",
    corpIdErr: false,
    corpIdErrTxt: "",
    recordDateErr: false,
    recordDateErrTxt: "",
    paymentDateErr: false,
    paymentDateErrTxt: "",
    grossPriceErr: false,
    grossPriceErrTxt: "",
    totalHoldingErr: false,
    totalHoldingErrTxt: "",
    taxYearErr: false,
    taxYearErrTxt:"",
    fileErr: false,
    fileErrTxt: "",
    validSetup: true,
    });

  //use of context FileUploadInfoProvider
  const { fileUploadData, setUploadData } = useFileUploadInfoData();

  useEffect(() => {
    console.log(getSecurityType(country, selectedOption));
    setUploadData({
      ...fileUploadData,
      securityType: getSecurityType(country, selectedOption),
      country: country,
      tax: selectedOption,
    });
  }, []);
  
  const handleFileInput = (event: React.ChangeEvent<HTMLInputElement>) => {
    const name = event.target.name;
    const files = event.target.files;

    if (files && event.target.files && event.target.files[0]) {
      const fileSize = event.target.files[0].size;
      const fileName = event.target.files[0].name;

      setUploadData({
        ...fileUploadData,
        [name]: files[0],
        attachedFileName: fileName,
        attachedFileSize: String(fileSize),
      });
    }
  };

  const handleChange = (
    event:
      | React.ChangeEvent<HTMLInputElement>
      | React.ChangeEvent<HTMLSelectElement>
  ) => {
    const target = event.target;
    const value = target.value;
    const name = target.name;
    setUploadData({ ...fileUploadData, [name]: value });
  };

  const handleDate = (date: Date | null, name: string) => {
    let dateAsString = "";
    if (date) {
      dateAsString =
        (date.getDate() < 10 ? "0" + date.getDate() : date.getDate()) +
        "/" +
        (date.getMonth() + 1 < 10
          ? "0" + (date.getMonth() + 1)
          : date.getMonth() + 1) +
        "/" +
        date.getFullYear();
    }
    setUploadData({ ...fileUploadData, [name]: dateAsString });
  };

  const setUserInfo = (event: MouseEvent<HTMLButtonElement>) => {
    if (!fileUploadData.filledByClick) {
      setUploadData({
        ...fileUploadData,
        salutation: userLoginData.salutation,
        firstName: userLoginData.firstName,
        lastName: userLoginData.lastName,
        customerOrg: userLoginData.customerOrg,
        phoneNbr: userLoginData.phoneNbr,
        email: userLoginData.email,
        filledByClick: event.type === "click" ? true : false,
      });
    }
  };

  const hideUserInfo = () => {
    if (!fileUploadData.filledByClick) {
      setUploadData({
        ...fileUploadData,
        salutation: "",
        firstName: "",
        lastName: "",
        customerOrg: "",
        phoneNbr: "",
        email: "",
      });
    }
  };

  return (
    <div>
      <p>Upload Beneficial Owner List - Step 4 of 5 </p>
      <div style={{ marginTop: "10px" }}>
        {displayCountryDesc(country, selectedOption)}
      </div>

      <FileUploadTexts country={country} errors={errors} />

      <div className="inline">
        <BOListTemplates country={country} />
        <DocuTemplates country={country} />
      </div>
      <div className="inline" style={{ marginLeft: "10px", width: "70%" }}>
        <p className="subTitle">File Upload Information</p>
        {country !== "Italy" && (
          <p>
            This session will expire in 4 hours. Please make sure you have
            completed the process within this time frame. After 4 hours the data
            registered are no more available and must be entered again.
          </p>
        )}
        <div className="greyStripe">
          <div className="inline" style={{ textAlign: "start" }}>
            My Contact Information
          </div>
          <div style={{ textAlign: "end", fontWeight: "normal" }}>
            <button
              className="buttonaslink"
              onMouseEnter={setUserInfo}
              onMouseLeave={hideUserInfo}
              onClick={setUserInfo}
            >
              Fill in using my User Profile
            </button>
          </div>

          <div
            className="inline tooltip"
            data-tooltip="The contact information entered here is 
                          used to reference the person who actually 
                          filled in this request."
          >
            <img src={info_small} alt="Clearstream Logo" />
          </div>

          <div
            className="tooltip"
            data-tooltip="Click this option to speed the form-filling process
                          by using the information you entered
                          when you registered to this site."
            style={{ marginLeft: "385px" }}
          >
            <img src={info_small} alt="Clearstream Logo" />
          </div>
        </div>

        <div className="clearBoth" />
        <Select
          label="Salutation: *"
          name="salutation"
          value={fileUploadData.salutation}
          error={errors.salutationErr}          
          handleChange={handleChange}
          options={["none", "Mr", "Mrs", "Ms"]}
        />
        <Input
          label="First Name *"
          name="firstName"
          value={fileUploadData.firstName}
          error={errors.firstNameErr}
          errorText= {errors.firstNameErrTxt}
          handleChange={handleChange}
          maxLength = {32}
        />
        <Input
          label="Last name: *"
          name="lastName"
          value={fileUploadData.lastName}
          error={errors.lastNameErr}
          errorText= {errors.lastNameErrTxt}
          handleChange={handleChange}
          maxLength = {64}
        />
        <Input
          label="Customer organisation: *"
          name="customerOrg"
          value={fileUploadData.customerOrg}
          error={errors.customerOrgErr}
          errorText= {errors.customerOrgErrTxt}
          handleChange={handleChange}
          maxLength = {96}
        />
        <Input
          label="Telephone number: *"
          name="phoneNbr"
          value={fileUploadData.phoneNbr}
          error={errors.phoneNbrErr}
          errorText= {errors.phoneNbrErrTxt}
          handleChange={handleChange}
          maxLength = {64}
        />
        <Input
          label="Email address: *"
          name="email"
          value={fileUploadData.email}
          error={errors.emailErr}
          errorText={errors.emailErrTxt}
          handleChange={handleChange}
          maxLength = {128}
        />
        <div className="clearBoth"></div>
        <div className="greyStripe">Send confirmation message to</div>
        <Input
          label="Email address:"
          name="email"
          value={fileUploadData.email}
          error={false}
          handleChange={handleChange}
          disabled={true}
          maxLength = {128}
        />
        <Input
          label="CC:"
          name="ccFirst"
          value={fileUploadData.ccFirst}
          error={errors.ccFirstErr}
          errorText= {errors.ccFirstErrTxt}
          handleChange={handleChange}
          maxLength = {128}
        />
        <Input
          label="CC:"
          name="ccSecond"
          value={fileUploadData.ccSecond}
          error={errors.ccSecondErr}
          errorText= {errors.ccSecondErrTxt}
          handleChange={handleChange}
          maxLength = {128}
        />
        <div className="clearBoth"></div>
        <div className="greyStripe">Clearstream Account Information</div>
        <Input
          label="Clearstream Account Number: *"
          name="acctNbr"
          value={fileUploadData.acctNbr}
          error={errors.acctNbrErr}
          errorText={errors.acctNbrErrTxt}
          handleChange={handleChange}
          maxLength={7}
        />
        <Select
          label="Platform: *"
          name="platform"
          value={fileUploadData.platform}
          error={errors.platformErr}
          handleChange={handleChange}
          options={
            country === "Japan"
              ? ["", "Creation"]
              : ["", "Creation", "CASCADE"]
          }
        />
        <div className="clearBoth"></div>
        <div className="greyStripe">Payment Details</div>
        {country !== "Germany" && (
          <>
            <div style={{ color: errors.securityCodeErr ? "red" : "black" }}>
              Security Code: *
            </div>

            <div className="inline" style={{ width: "50%" }}>
              <div
                style={{
                  marginLeft: "20px",
                  color: errors.isinErr ? "red" : "black",
                }}
              >
                ISIN
              </div>
            </div>
            <div className="inline" style={{ width: "50%" }}>
              <input
                style={{ width: "100%" }}
                name="isin"
                value={fileUploadData.isin}
                onChange={handleChange}
              />
              {errors.isinErrTxt}
            </div>
            <div
              style={{
                fontWeight: "bold",
                marginBottom: "2px",
                marginLeft: "20px",
              }}
            >
              or
            </div>
            <div
              className="inline"
              style={{ width: "50%", marginBottom: "2px" }}
            >
              <div
                style={{
                  marginLeft: "20px",
                  color: errors.commonCodeErr ? "red" : "black",
                }}
              >
                Common Code
              </div>
            </div>
            <div
              className="inline"
              style={{ width: "50%", marginBottom: "2px" }}
            >
              <input
                style={{ width: "100%" }}
                name="commonCode"
                value={fileUploadData.commonCode}
                onChange={handleChange}
              />
              {errors.commonCodeErrTxt}
            </div>
            <Input
              label="Security Name: *"
              name="securityName"
              value={fileUploadData.securityName}
              error={errors.securityNameErr}
              errorText= {errors.securityNameErrTxt}
              handleChange={handleChange}
              maxLength = {80}
            />
            <Input
              label="CORP ID: *"
              name="corpId"
              value={fileUploadData.corpId}
              error={errors.corpIdErr}
              errorText={errors.corpIdErrTxt}
              handleChange={handleChange}
              maxLength = {16}
            />
            <Datepicker
              label="Record Date: *"
              name="recordDate"
              value={convertStringToDate(fileUploadData.recordDate)}
              error={errors.recordDateErr}
              handleDate={handleDate}
              errorText={errors.recordDateErrTxt}
            />
            {country !== "South Korea" && (
              <>
                <Datepicker
                  label={
                    country === "Japan" ? "Payment Date:" : "Payment Date: *"
                  }
                  name="paymentDate"
                  value={convertStringToDate(fileUploadData.paymentDate)}
                  error={errors.paymentDateErr}
                  handleDate={handleDate}
                  errorText={errors.paymentDateErrTxt}
                />
              </>
            )}
            <Input
              label="Gross Price per Unit:"
              name="grossPrice"
              value={fileUploadData.grossPrice}
              error={errors.grossPriceErr}
              errorText={errors.grossPriceErrTxt}
              handleChange={handleChange}
              maxLength = {20}
            />
            <Input
              label="Total Holding: *"
              name="totalHolding"
              value={fileUploadData.totalHolding}
              error={errors.totalHoldingErr}
              handleChange={handleChange}
              errorText={errors.totalHoldingErrTxt}              
            />
          </>
        )}
        {country === "Germany" && (
          <Input
            label="Tax Year: *"
            name="taxYear"
            value={fileUploadData.taxYear}
            error={errors.taxYearErr}
            errorText={errors.taxYearErrTxt}
            handleChange={handleChange}
            maxLength = {4}
          />
        )}
        <div className="clearBoth"></div>
        <div
          className="greyStripe"
          style={{ color: errors.fileErr ? "red" : "black" }}
        >
          B.O. List file selection
        </div>
        <p>
          <strong>Selected File: </strong>
          {fileUploadData.attachedFileName || "No file has been selected"} 
        </p>
        <input
          type="file"
          accept={allowedFileExtensions(country)}
          name="attachedFile"
          onChange={handleFileInput}
        ></input>

        <p style={{ color: "red" }}>{errors.fileErrTxt}</p>

        <ButtonNavigation
          setSelectedPage={setSelectedPage}
          selectedPage={selectedPage}
          setSelectedCountry={setSelectedCountry}
          country={country}
          setSelectedOption={setSelectedOption}
          selectedOption={selectedOption}
          setErrors={setErrors}
          setWarnings={setWarnings}
        />
      </div>
    </div>
  );
};

export default FileUploadInformation;
